import { Link } from "react-router-dom";
import { cn } from "../lib/utils";
import logoSrc from "../assets/vpm-logo.png";

const SIZES = {
  sm: "h-9",
  md: "h-11",
  lg: "h-14",
  xl: "h-[4.25rem]",
} as const;

interface BrandLogoProps {
  size?: keyof typeof SIZES;
  className?: string;
  to?: string | null;
  /** Use on dark backgrounds (e.g. auth hero panel). */
  variant?: "default" | "white";
}

export function BrandLogo({ size = "md", className, to = "/", variant = "default" }: BrandLogoProps) {
  const image = (
    <img
      src={logoSrc}
      alt="Virtual Peace of Mind"
      className={cn(
        "w-auto max-w-[min(100%,280px)] shrink-0 object-contain object-left",
        SIZES[size],
        variant === "white" && "brightness-0 invert",
      )}
    />
  );

  const rootClass = cn("inline-flex min-w-0 items-center transition opacity-95 hover:opacity-100", className);

  if (to) {
    return (
      <Link to={to} className={rootClass} aria-label="Virtual Peace of Mind home">
        {image}
      </Link>
    );
  }

  return <span className={rootClass}>{image}</span>;
}
